module.exports = __webpack_public_path__ + "img/马元安@2x.3de2e2ff.png";